import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_settings_page-opt_out_of_all_faire_marketing_emails-click';

/**
 * Tracks click of "Opt out of all Faire marketing emails" from email preferences page.
 */
export function trackRetailerSettingsPageOptOutOfAllFaireMarketingEmailsClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
